//sessionStorage json 
//solar sun
//2018-02-06 15:09:03
// define(function (require, exports, module) {
//     var obj = {};
//     //存
//     obj.Set = function (key, value) {
//         sessionStorage.setItem(key, JSON.stringify(value));
//     }
//     //取
//     obj.Get = function (key) {
//         return JSON.parse(sessionStorage.getItem(key));
//     }
//     //单清
//     obj.Remove = function (key) {
//         sessionStorage.removeItem(key);
//     }
//     //全清
//     obj.ClearAll = function () {
//         sessionStorage.clear();
//     }
//     return obj;
// });

export default {
  Set: function (key, value) {
    sessionStorage.setItem(key, JSON.stringify(value));
  },
  Get: function (key) {
    return JSON.parse(sessionStorage.getItem(key));
  },
  LocalSet: function (key, value) {
    localStorage.setItem(key, JSON.stringify(value));
  },
  LocalGet: function (key) {
    return JSON.parse(localStorage.getItem(key));
  },
  //单清
  Remove: function (key) {
    sessionStorage.removeItem(key);
  },
  //全清
  ClearAll: function () {
    sessionStorage.clear();
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/sessionStorage.js